import { render } from "./ToWhomForm.vue?vue&type=template&id=132957c2"
import script from "./ToWhomForm.vue?vue&type=script&lang=js"
export * from "./ToWhomForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__